<div class="lua-message-erreur">
  <lua-icone
    mode="outlined"
    [iconName]="iconName"
    color="Error"
    fontSize="40px"
  ></lua-icone>
  <h4>{{ messageTitle }}</h4>
  <small>{{ messageDetail }}</small>
  <div class="boutton">
    <lua-action-secondaire
      [fullWidth]="false"
      [size]="size"
      [libelle]="buttonLabel"
	  [color]="buttonColor"
      [avecIcone]="!!buttonIconName"
      [nomIcone]="buttonIconName"
      positionIcone="L"
      (click)="onAction($event)"
    >
    </lua-action-secondaire>
  </div>
</div>
